export class Step {
  component: string
  title: string
  subTitle?: string

  constructor (component: string, title: string, subTitle?: string) {
    this.component = component
    this.title = title
    this.subTitle = subTitle
  }
}
